export default __webpack_public_path__ + "static/media/about-waves-icon.af0c340c.svg";